import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import PageHeader from '@lib/layouts/DashboardLayout/PageHeader/PageHeader';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import DashboardContentMaxWidth from '@lib/layouts/DashboardLayout/DashboardContentMaxWidth/DashboardContentMaxWidth';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import Form from '@lib/components/ReactHookForm/FormContainer';
import getChecklistFormFields from 'routes/FormChecklists/utils/getChecklistFormFields';
import ChecklistFormActions from 'routes/FormChecklists/components/ChecklistFormActions/ChecklistFormActions';
import getDefaultValuesFromQueryData from 'routes/FormChecklists/utils/getDefaultValuesFromQueryData';
import useFormChecklistActions from './utils/useFormChecklistActions';

export default function FormChecklist({ isEdit }: { isEdit?: boolean }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { data, onSubmitForm, loading, onCancel, firstLoading, graphQLErrors } =
    useFormChecklistActions({
      isEdit,
    });
  const formFields = getChecklistFormFields({ t });
  const defaultValues = getDefaultValuesFromQueryData(data);
  const breadCrumbsData = getBreadCrumbsDataByKey({
    pathname,
    t,
    entity: data,
  });
  const actionsComponentProps = {
    onCancel,
    isEditForm: isEdit,
  };
  const title = isEdit ? t('edit-checklist') : t('add-new-checklist');
  return (
    <>
      <BreadCrumbs data={breadCrumbsData} />
      {firstLoading ? (
        <CircleLoader />
      ) : (
        <DashboardContentMaxWidth>
          <PageHeader title={title} />
          <PageBody>
            <WhiteBox>
              <Form
                actionsComponent={ChecklistFormActions}
                actionsComponentProps={actionsComponentProps}
                defaultValues={defaultValues}
                fields={formFields}
                graphQLErrors={graphQLErrors}
                loading={loading}
                onSubmit={onSubmitForm}
              />
            </WhiteBox>
          </PageBody>
        </DashboardContentMaxWidth>
      )}
    </>
  );
}
